import { TEventTypes } from './gameState';
import PanicAction from '@/components/footer/PanicAction.vue';
import PlayersAction from '@/components/footer/PlayersAction.vue';
import WeatherAction from '@/components/footer/WeatherAction.vue';
import SettingsAction from '@/components/footer/SettingsAction.vue';

export const FOOTER_BUTTONS: {
  [key: string]: {
    buttonName: string;
    imgUrl: string;
    imgUrlActive: string;
    heading: string;
    headingImgUrl: string;
    component: any;
    eventId?: TEventTypes;
  };
} = {
  DANGER: {
    buttonName: 'DANGER',
    imgUrl: '/images/panic.svg',
    imgUrlActive: '/images/alert_white.svg',
    heading: 'DANGER!',
    headingImgUrl: '/images/panic_active.svg',
    component: PanicAction,
    eventId: TEventTypes.PRICE_DANGER,
  },
  PLAYERS: {
    buttonName: 'PLAYERS',
    imgUrl: '/images/players.svg',
    imgUrlActive: '/images/players_active.svg',
    heading: 'Player Alert',
    headingImgUrl: '/images/alert.svg',
    component: PlayersAction,
  },
  WEATHER: {
    buttonName: 'WEATHER',
    imgUrl: '/images/weather.svg',
    imgUrlActive: '/images/weather_active.svg',
    heading: 'Weather Alert',
    headingImgUrl: '/images/alert.svg',
    component: WeatherAction,
    eventId: TEventTypes.WEATHER,
  },
  SETTINGS: {
    buttonName: 'SETTINGS',
    imgUrl: '/images/settings.svg',
    imgUrlActive: '/images/settings_active.svg',
    heading: 'Settings',
    headingImgUrl: '/images/settings_active.svg',
    component: SettingsAction,
  },
};
